import {PERMISSION_ACTIONS, PERMISSION_SUBJECTS} from './permissionsUtils';
import {USER_ROLES} from '../../../views/pages/users/userUtils';
import {store} from '../../../services/redux/storeConfig/store';

export const arrangeUserSession = (userData) => {
	let response = {
		user_id: null,
		email: null,
		name: null,
		lastname: null,
		avatar: null,
		role_slug: null,
		role: null,
		permissions: [],
	};
	if (userData) {
		response.user_id = userData.id;
		response.email = userData.correo;
		response.avatar = userData.avatar;
		response.permissions = userData.permisos;
		if (userData.perfil) {
			response.name = userData.perfil.nombres
			response.lastname = userData.perfil.apellidos
		}
		if (userData.rol) {
			response.role_slug = userData.rol.slug
			response.role = userData.rol.titulo
		}
	}

	return response;
}

export const defineRulesFor = (auth) => {
	const commonPermissions = [
		{
			subject: PERMISSION_SUBJECTS.home.name,
			action: PERMISSION_ACTIONS.read.name
		},
		{
			subject: PERMISSION_SUBJECTS.calendar.name,
			action: PERMISSION_ACTIONS.read.name
		},
		{
			subject: PERMISSION_SUBJECTS.calendar.name,
			action: PERMISSION_ACTIONS.create.name
		},
		{
			subject: PERMISSION_SUBJECTS.calendar.name,
			action: PERMISSION_ACTIONS.update.name
		},
		{
			subject: PERMISSION_SUBJECTS.calendar.name,
			action: PERMISSION_ACTIONS.delete.name
		},
		{
			subject: PERMISSION_SUBJECTS.notifications.name,
			action: PERMISSION_ACTIONS.read.name
		},
		{
			subject: PERMISSION_SUBJECTS.authorizationTokens.name,
			action: PERMISSION_ACTIONS.read.name
		},
		{
			subject: PERMISSION_SUBJECTS.authorizationTokens.name,
			action: PERMISSION_ACTIONS.create.name
		},
		{
			subject: PERMISSION_SUBJECTS.authorizationTokens.name,
			action: PERMISSION_ACTIONS.update.name
		},
	];
	const permissions = [];
	switch (auth.role_slug.toUpperCase()) {
		case USER_ROLES.superUsuario.slug:
			Object.keys(PERMISSION_SUBJECTS).forEach((subjectKey) => {
				const subject = PERMISSION_SUBJECTS[subjectKey].name;
				Object.keys(PERMISSION_ACTIONS).forEach((actionKey) => {
					const action = PERMISSION_ACTIONS[actionKey].name;
					permissions.push({
						action: action,
						subject: subject
					})
				});
			});
			break;
		default:
			permissions.push(...commonPermissions);
			auth.permissions.forEach((permission) => {
				permission.actions.forEach((action) => {
					permissions.push({
						subject: permission.subject,
						action: action,
					});
				});
			});
			break;
	}
	return permissions;
}

export const canDo = (props = {}) => {
	let canDo = false;
	const {action, subject} = props;
	const permissions = store.getState().auth.session.data.permissions;
	if (permissions) {
		canDo = permissions.filter((permission) => {
			return permission.action === action && permission.subject === subject
		}).length > 0;
	}
	return canDo;
}
